import React from 'react';
import { Modal } from 'antd';
import SeoForm from './SeoForm'
// import { clearCache } from '../../utils/clearCache';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function EditSeo({ businessToken }) {
    const general = useGeneralStore();
    const { business } = usePersistedStore()
    const visible = general.view.seoEditModal;
    const selectedHead = business.businesses.selectedHead;

    return (
        <Modal
            style={{
                top: 25,
            }}
            className="custom-table seo-modal"
            title="ویرایش صفحه"
            visible={visible}
            footer={false}
            destroyOnHidden={true}
            onCancel={() => general.ToggleSeoEditModal()}>
            <SeoForm
                onSubmit={() => {
                    general.ToggleSeoEditModal()
                    general.NotifSuccess('اطلاعات سئو شریک تجاری با موفقیت بروزرسانی شد')
                    // clearCache();
                }}
                head={selectedHead}
                businessToken={businessToken}
            />
        </Modal>
    )
}
